

export const fetchImageSuccess = (status) => ({
  type: 'FETCH_IMAGE_SUCCESS',
  status: status,
});
